import React from 'react';
import { Link } from 'react-router-dom';
import Hero from '../../components/public/Hero';

const About = () => {
    const teamValues = [
        {
            icon: '',
            title: 'Our Mission',
            description: 'To empower individuals and organizations with clarity, enabling them to achieve their full potential through systematic guidance and unwavering support.',
            keywords: ['Integrity', 'Independence', 'Clarity']
        },
        {

            title: 'Our Vision',
            description: 'To be the leading catalyst for transformational clarity, creating a world where every individual and organization operates with purpose and direction.',
            keywords: ['Integrity', 'Independence', 'Clarity']
        },
        {

            title: 'Our Values',
            description: 'Integrity, excellence, innovation, and empowerment guide everything we do. We believe in sustainable growth and meaningful impact.',
            keywords: ['Integrity', 'Independence', 'Clarity']
        }
    ];

    const milestones = [
        {
            year: '2014',
            title: 'Foundation',
            description: 'Started with a vision to bring clarity to businesses',
            icon: '🌱'
        },
        {
            year: '2017',
            title: 'Expansion',
            description: 'Expanded services to include personal development',
            icon: '🚀'
        },
        {
            year: '2020',
            title: 'Innovation',
            description: 'Launched our proprietary clarity assessment system',
            icon: '💡'
        },
        {
            year: '2024',
            title: 'Excellence',
            description: 'Recognized as industry leaders in clarity coaching',
            icon: '🏆'
        },
        {
            year: '2026',
            title: 'Future Vision',
            description: 'Expanding clarity tools and reaching more families',
            icon: '🔮'
        }
    ];

    const stats = [
        { number: '500+', label: 'Families Guided' },
        { number: '95%', label: 'Success Rate' },
        { number: '10+', label: 'Years Experience' },
        { number: '50+', label: 'Expert Team' }
    ];

    const whyChooseUs = [
        {

            title: 'Proven Methodology',
            description: 'Our systematic approach is backed by years of research and real-world success stories.'
        },
        {

            title: 'Personalized Approach',
            description: 'Every solution is tailored to your unique needs, challenges, and aspirations.'
        },
        {

            title: 'Data-Driven Insights',
            description: 'We use advanced analytics to provide actionable insights and measurable results.'
        },
        {

            title: 'Continuous Support',
            description: 'Our commitment does not end with delivery. We provide ongoing guidance and support.'
        },

    ];

    return (
        <div className="about-page-enhanced">
            <Hero
                title="About Yathartha"
                subtitle="Who We Are"
                description="Dedicated to bringing clarity and purpose to individuals and organizations worldwide"
                backgroundImage="/report.jpg"
            />

            <section className="mvv-section">
                <div className="container">
                    <div className="mvv-grid">
                        {teamValues.map((value, index) => (
                            <div
                                key={index}
                                className="mvv-card"
                                style={{ animationDelay: `${index * 0.15}s` }}
                            >
                                <div className="mvv-icon">{value.icon}</div>
                                <h3>{value.title}</h3>
                                <p>{value.description}</p>
                                <div className="value-keywords">
                                    {value.keywords.map((keyword, idx) => (
                                        <span key={idx} className="keyword-badge">{keyword}</span>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="story-section-enhanced">
                <div className="container">
                    <div className="story-content">
                        <div className="story-text">
                            <h2>Our Story</h2>

                            <div className="story-problem">
                                <h3>Why Yathartha Was Needed</h3>
                                <p className="problem-statement">
                                    "We saw people earning well, yet feeling lost about money decisions."
                                </p>
                                <p>
                                    In today's financial industry, we noticed a troubling pattern: individuals and families with good incomes were making poor financial decisions—not because they lacked resources, but because they lacked clarity.
                                </p>
                            </div>

                            <p className="story-intro">
                                Founded with a singular vision to bring clarity to a complex world, Yathartha has grown from a small consultancy to a trusted partner for hundreds of individuals and organizations.
                            </p>
                            <p>
                                We believe that clarity is the foundation of success. Whether you're an individual seeking direction or an organization aiming for strategic alignment, we provide the tools, insights, and support needed to achieve your goals.
                            </p>
                            <p>
                                Our journey has been marked by continuous learning, innovation, and an unwavering commitment to our clients' success. Every milestone we've achieved has been a testament to the trust our clients place in us.
                            </p>
                        </div>
                        <div className="story-visual">
                            <div className="story-image-placeholder">
                                <span className="placeholder-icon">📖</span>
                                <p style={{ color: '#069668' }}>Our Journey</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* <section className="stats-section">
                <div className="container">
                    <div className="section-title">
                        <h2 className="section-heading">Our Impact in Numbers</h2>
                        <p className="section-description">
                            Measurable results that speak to our commitment and expertise
                        </p>
                    </div>
                    <div className="stats-grid">
                        {stats.map((stat, index) => (
                            <div
                                key={index}
                                className="stat-box"
                                style={{ animationDelay: `${index * 0.1}s` }}
                            >
                                <div className="stat-icon">{stat.icon}</div>
                                <div className="stat-number">{stat.number}</div>
                                <div className="stat-label">{stat.label}</div>
                            </div>
                        ))}
                    </div>
                    <p className="stats-disclaimer">
                        * Results vary based on individual circumstances and commitment to the process.
                    </p>
                </div>
            </section> */}

            <section className="timeline-section">     
                <div className="container">
                    <div className="section-title">
                        <h2 className="section-heading" style={{ color: '#069668' }}>Our Journey</h2>
                        <p className="section-description">
                            Key milestones that shaped who we are today
                        </p>
                    </div>
                    <div className="about-timeline">
                        {milestones.map((milestone, index) => (
                            <div
                                key={index}
                                className="milestone"
                                style={{ animationDelay: `${index * 0.15}s` }}
                            >
                                <div className="milestone-year">{milestone.year}</div>
                                <div className="milestone-icon">{milestone.icon}</div>
                                <div className="milestone-content">
                                    <h3>{milestone.title}</h3>
                                    <p>{milestone.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="founder-leadership-section">
                <div className="container">
                    <div className="section-title">
                        <h2 className="section-heading">Leadership</h2>
                    </div>
                    <div className="founder-card">
                        <div className="founder-image">
                            <img src="/akshay kumar.png" alt="Akshaykumar Sawant" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%', backgroundColor: '#f0f0f0' }} />
                        </div>
                        <div className="founder-info">
                            <h3>Akshay kumar Sawant</h3>
                            <p className="founder-role">Founder & Chief Clarity Officer</p>
                            <p className="founder-philosophy">
                                "Financial clarity isn't about complex strategies—it's about understanding your reality and making conscious decisions. Our role is to illuminate the path, not push you down it."
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="ethics-section">
                <div className="container">
                    <div className="ethics-card">
                        <div className="ethics-icon">🛡️</div>
                        <h2>Our Independence Statement</h2>
                        <p className="ethics-statement">
                            We are <strong>not affiliated</strong> with mutual fund houses, banks, insurance companies, or any financial product providers.
                        </p>
                        <p>
                            This independence ensures that our advice is always in your best interest, free from conflicts or commission-based incentives.
                        </p>
                        <div className="ethics-badges">
                            <span className="ethics-badge">✓ No Commissions</span>
                            <span className="ethics-badge">✓ No Product Pushing</span>
                            <span className="ethics-badge">✓ 100% Independent</span>
                        </div>
                    </div>
                </div>
            </section>

            <section className="why-choose-section">
                <div className="container">
                    <div className="section-title">
                        <h2 className="section-heading">Why Choose Yathartha</h2>
                        <p className="section-description">
                            What sets us apart in delivering exceptional results
                        </p>
                    </div>
                    <div className="why-grid">
                        {whyChooseUs.map((item, index) => (
                            <div
                                key={index}
                                className="why-card"
                                style={{ animationDelay: `${index * 0.1}s` }}
                            >
                                <div className="why-icon">{item.icon}</div>
                                <h3>{item.title}</h3>
                                <p>{item.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* <section className="cta-section">
                <div className="container">
                    <div className="cta-content">
                        <h2>Ready to Begin Your Transformation?</h2>
                        <p>Join hundreds who have discovered clarity and achieved remarkable success</p>
                        <div className="cta-buttons">
                            <Link to="/begin-with-clarity" className="cta-button primary">
                                Start Your Journey
                            </Link>
                            <Link to="/contact" className="cta-button dark">
                                Learn More
                            </Link>
                        </div>
                    </div>
                </div>
            </section> */}
        </div>
    );
};

export default About;
